<template>
  <v-dialog 
    v-model="activeMode"  
    max-width="400"
    @click:outside="closeForm()"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark v-on="on">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>Добавление клиента</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeForm()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="mt-7">
        <v-form ref="form" v-model="isValid" :disabled="loadingCreate">
          <v-alert 
            dense 
            outlined
            type="error" 
            :value="Boolean(serverError)"
            transition="scale-transition"
          >
            {{ serverError }}
          </v-alert>

          <v-autocomplete 
            label="Сайт *" 
            v-model="customer.site"
            :items="sitesSelectData"
            clearable
            filled
            :rules="[v => !!v || 'Выберите сайт.']"
            @focus="serverError = ''"
          >
          </v-autocomplete>

          <v-text-field
            v-model="customer.phoneNumber"
            label="Номер телефона *"
            filled
            :prefix="customer.phoneNumberPrefix"
            @focus="customer.phoneNumberPrefix = '+7'; serverError = '';"
            @blur="customer.phoneNumber || (customer.phoneNumberPrefix = '')"
            v-mask="'##########'"
            :rules="[v => !!v || 'Введите номер телефона.', v => v.length == 10 || 'Введите правильный номер.']"
          >
          </v-text-field>

          <v-select
            v-model="customer.utm.source"
            label="Канал привлечения *"
            :items="utmSources"
            filled
          ></v-select>

          <v-textarea
            v-model="customer.comment"
            label="Комментарий"
            filled
          ></v-textarea>

        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeForm()">Закрыть</v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="save"
          :disabled="loadingCreate"
          :loading="loadingCreate"
        >Сохранить</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'customer-create',

  data() {
    return {
      activeMode: false,
      isValid: false,
      serverError: false,

      customer: this.setDefaultObj(),

      utmSources: [
        {
          text: 'Email / Мессенджеры',
          value: ''
        },
        {
          text: 'Instagram - Direct',
          value: 'instagram'
        },
        {
          text: 'ВКонтакте - Сообщения',
          value: 'vk'
        }
      ]
    };
  },

  methods: {
    setDefaultObj() {
      return {
        siteId: null,
        phoneNumber: '',
        phoneNumberPrefix: '',
        comment: '',
        utm: {
          source: 'instagram',
          campaign: '',
        }
      };
    },

    save() {
      this.$refs.form.validate();
      if (this.isValid) {
        if (this.customer.utm.source) {
          this.customer.utm.campaign = 'direct';
        } else {
          this.customer.utm.campaign = '';
        }
        this.$store.dispatch('customers/create', this.customer)
        .then(res => {
          this.$store.dispatch('showMessage', res.message);
          this.closeForm();
        })
        .catch(err => {
          this.serverError = err.message;
        })
      }
    },

    closeForm() {
      this.activeMode = false;
      this.customer = this.setDefaultObj();
      this.serverError = '';
      this.$refs.form.resetValidation();
    },
  },

  computed: {
    ...mapGetters('sites', ['sitesSelectData']),
    ...mapGetters('customers', ['loadingCreate'])
  }
}
</script>